{
	"visible": {
		"development": "6LeJjwcTAAAAAMcXZzXd2tIrbsPFcAsuN7vmkEHq",
		"demo": "6LcIuQcTAAAAANAi5HDO6s828-mJguw0UAAS6W5Q",
		"staging": "6LfRugcTAAAAAMP5c7_ZLLBkLuBUqUKlTIePQNMb",
		"production": "6LfSugcTAAAAAD9wGAbXhcdcFxL9vCyWrapKC96o"
	},
  	"invisible": {
		"development": "6LfsJgcUAAAAANdUhQVKC8FCg4-SISoEWCjxktrp",
		"demo": "6LfsJgcUAAAAANdUhQVKC8FCg4-SISoEWCjxktrp",
		"staging": "6LfpJgcUAAAAAG415YiVtd91Ob0I6qeWNmZJ3dFM",
		"production": "6LfqJgcUAAAAAA8YY8R29J8lQIh5rFZzG3Don_X7"
	}
}
